module.exports = __webpack_public_path__ + "assets/5b85a232ba67991ff5cc3657bf61cece.mp4";